module.exports = __webpack_public_path__ + "img/36.1a072651.jpg";